import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProductGallery } from './components/ProductGallery';
import { Testimonials } from './components/Testimonials';
import { VisualSystem } from './components/VisualSystem';
import { WhyEducators } from './components/WhyEducators';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { VolumesSection } from './components/VolumesSection';
import { VisualExplain } from './components/VisualExplain';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { EducatorValues } from './components/EducatorValues';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { initMetaPixel, META_PIXEL_ID } from './utils/tracking';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-stone-50 text-stone-800 selection:bg-rose-700/20 selection:text-rose-900" data-id="element-0" data-mp="3mkhlps1j704z">
      <main data-id="element-1" data-mp="3rcsxpt9jqcdw">
        <Hero data-id="element-2" data-mp="3rd19fhtxnbni" />
        <ProductGallery data-id="element-3" data-mp="3relumgucxi8p" />
        <Testimonials data-id="element-4" data-mp="5opww5kum4f" />
        <WhyEducators data-id="element-5" data-mp="4wxfu7a14id" />
        <VisualSystem data-id="element-6" data-mp="5gbgztt38r4" />
        <PainPoints data-id="element-7" data-mp="7ssnarqpf34" />
        <SolutionReveal data-id="element-8" data-mp="2zld1r8m3ndb0" />
        <VolumesSection data-id="element-9" data-mp="2zm4wkh7vh708" />
        <VisualExplain data-id="element-10" data-mp="2zmwi0z7r9ocs" />
        <BonusSection data-id="element-11" data-mp="2zng1wlgyumtg" />
        <PricingSection data-id="element-12" data-mp="33m5am0r27g6r" />
        <EducatorValues data-id="element-13" data-mp="33nq921ghvj9w" />
        <Guarantee data-id="element-14" data-mp="33myl9ct52pu6" />
        <FAQ data-id="element-15" data-mp="33ohzyyz5cstu" />
        <FinalCTA data-id="element-16" data-mp="38m1elzzrb7mb" />
      </main>
      <Footer data-id="element-17" data-mp="38kqau06b9zv7" />
      <PurchaseNotifications data-id="element-18" data-mp="38k6v8q44vnkc" />
      <noscript data-id="element-19" data-mp="38o4fjf2g6l5t">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-20" data-mp="3dkl5met7j9lj" />
      </noscript>
    </div>;
}